export abstract class SharedAuthService {
  abstract login(
    redirectTo: string,
    params?: unknown,
    encodedParams?: unknown
  ): void;
}
